var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMouseRotate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 50,
    viewBox: "0 0 78 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 25.389 11.078 6.43v-12.86L0 25.389Zm9.97 1.113h9.97v-2.227H9.97v2.227Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m77.497 25.389-11.078-6.43v12.86l11.078-6.43Zm-19.94 1.113h9.97v-2.227h-9.97v2.227Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.763 49.5c-8.283 0-14.997-6.75-14.997-15.077v-24.5C23.766 4.718 27.96.5 33.139.5h11.248c5.178 0 9.373 4.218 9.373 9.423v24.5c0 8.326-6.714 15.077-14.997 15.077Z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.267 3.013 31.265.5h7.5v12.85c0 1.23-.993 2.227-2.216 2.227h-13.11l.327-6.91 2.5-5.654Z",
    fill: "#fff"
  })));
};
export { SvgMouseRotate as ReactComponent };